/* eslint-disable react-hooks/exhaustive-deps */
import ModalAsistencias from 'components/AutoMex/ModalAsistencias';
import ModalCoberturas from 'components/AutoMex/ModalCoberturas';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter,TextInput } from 'components/InputsMex/inputs';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import TARJETAS from 'utils/constants/TARJETAS';
import { getColorByPlan } from 'utils/funciones';
import iconCar from '../../assets/img/mex/auto/icon-planes.png';

const ResumenDatosPlan = ({
  plan,
  tarifar,
  datosTarifacion,
  asistencias,
  coberturasAdicionales,
  labelMarcaAuto,
  cotizacion,
  recalculando,
  changeDescuentoRecargo,
  showDescuentoVariable,
  addWarningToast
}) => {
  const [showOpciones, setshowOpciones] = useState(false);
  const [showLogos, setShowLogos] = useState(false);

  const { parametrosPago } = useSelector((state) => state.cotizacionReducer);

  const methods = useFormContext();

  const { getValues } = methods;

  const onChangeFormPago = (value) => {
    if (value.onChange === 'recalcular') {
      tarifar({
        idPlazo: value.id,
        formaPago: value.tipo,
        labelPlazo: value.label,
      });
      setShowLogos(false);
    } else {
      setShowLogos(true);
    }
    setshowOpciones(value?.mostrarSubopciones);
  };

  const onChangePlazo = (value) => {
    const formaPago = getValues('formaPago');
    tarifar({
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    });
  };

  const setCombos = async () => {
    try {
      const { formasPago, plazos } = parametrosPago;
      const defaultData = {};

      if (datosTarifacion.formaPago === 'contado') {
        const forma = formasPago.find(
          (e) => Number(e?.value?.id) === Number(datosTarifacion.idPlazo),
        );
        defaultData.formaPago = forma.value;
      } else {
        //mesesSinIntereses
        const item = formasPago.find(
          (e) => e.value.tipo === datosTarifacion.formaPago,
        );
        defaultData.formaPago = item.value;

        const plazo = plazos.find(
          (e) => Number(e.value.ID) === Number(datosTarifacion.idPlazo),
        );
        defaultData.idPlazo = plazo?.value;
        setShowLogos(true);
        setshowOpciones(true);
      }
      methods.reset({ ...defaultData });
    } catch (error) {}
  };

  const onChangeDeducible = async () => {
    const valorDescuento = getValues('descuentoVariaSelecciono')  
    const min = cotizacion?.valDescuentoMaximo
    const max = cotizacion?.valRecargoMaximo    
    if(valorDescuento >= min && valorDescuento <= max){      
      const formaPago = getValues('formaPago');
      const idPlazo = getValues('idPlazo');
      if (idPlazo) {
        tarifar({
          idPlazo: idPlazo.ID,
          formaPago: formaPago.tipo,
          labelPlazo: idPlazo.Name,
        });
      }
      tarifar({
        idPlazo: formaPago.id,
        formaPago: formaPago.tipo,
        labelPlazo: formaPago.label,
      });
    }
    else{      
      addWarningToast(cotizacion?.descuentoVariaMensaje);
    }
    changeDescuentoRecargo(false)
  };

  

  useEffect(() => {
    setCombos();
  }, []);

  return (
    <React.Fragment>
      <div className="col-10 col-md-6 border-mex-ap ">
        <div className="row">
          <div className="col-11 mt-5 mx-auto">

            <div className="row justify-content-center mt-3 mb-5">
              <div
                className="col-11 col-md-8 text-center styleborder"
                style={{ border: `2px solid ${getColorByPlan(plan.id)}` }}
              >
                <div
                  className="text-center"
                  style={{
                    backgroundColor: getColorByPlan(plan.id),
                    fontSize: '20px',
                    paddingBottom: '0.5rem',
                    paddingTop: '0.3rem',
                    width: '100%',
                    margin: '0 0 0 0 ',
                    paddingLeft: '0',
                    paddingRight: '0',
                  }}
                >
                  <h4 className="font-mex text-mex mt-2 res-title-auto">
                    ¡Has elegido el paquete {plan.producto}!
                  </h4>
                </div>
                <img
                  src={iconCar}
                  className="img-fluid"
                  alt=""
                  style={{ height: '100px', marginTop: '1em' }}
                />
                <h2 className="font-mex" style={{ fontSize: '2.5em' }}>
                  ${datosTarifacion?.primaTotal}{' '}
                  {datosTarifacion.monedaSimbolo.toLowerCase()}
                </h2>
              </div>
            </div>
          </div>

          <div
            className="row col-lg-12"
            style={{ paddingBottom: '4rem', paddingLeft: '2em' }}
          >
            <div
              className="row col-lg-12"
              style={{
                color: '#001871',
                fontSize: '25px',
                paddingBottom: '1rem',
                width: '100%',
                lineHeight: '1em',
                margin: 'auto',
                textAlign: 'center',
              }}
            >
              {labelMarcaAuto}
            </div>

            <div className="col-12" style={{ paddingLeft: '1em' }}>
              <h2 className="font-mex mb-3">
                Datos del paquete {plan.producto.toLowerCase()}
              </h2>
              {plan.coberturas.map((cob, index) => (
                <div className="row" key={index}>
                  <div className="col-12 align-self-center">
                    <p
                      className="font-source-sans-regular"
                      style={{
                        fontSize: '20px',
                        fontWeight: '100',
                        marginBottom: '-0.5em',
                      }}
                    >
                      {cob.nombre}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <ModalAsistencias ocupaciones={asistencias} />
            <ModalCoberturas ocupaciones={coberturasAdicionales} />
          </div>          
          {cotizacion?.descuentoVaria === true &&
            	<div className="row col-12">
                  <div className="col-xl-6">
                    <SimpleContainer
                      name="descuentoVariaSelecciono"
                      label="Descuento"
                      info ={cotizacion?.descuentoVariaMensajeToolTip}
                    >                  
                      <TextInput
                        inputProps={{
                          name: "descuentoVariaSelecciono",
                          type: 'number'                      
                        }}
                        rules={{ required: 'Solo se permite valores numéricos' }}
                        defaultValue={cotizacion?.descuentoVariaSelecciono}
                        onChangeFn={()=>changeDescuentoRecargo(true)}
                      />
                    </SimpleContainer>
                    {showDescuentoVariable &&                  
                        <button
                          className="btn btn-calcular-api"
                          onClick={onChangeDeducible}
                          type="submit"                                                  
                        >
                          recalcular totales
                        </button>            
                    }
                  </div>
                  
                  
              </div>              
          }       
        
          <div className="col-12">
            <div className="row">
              <div className="col-xl-6">
                <SimpleContainer name="formaPago" label="Opción de pago">
                  <DropDownFilter
                    name="formaPago"
                    filter={false}
                    rules={{ required: 'Obligatorio' }}
                    disabled={recalculando}
                    options={parametrosPago.formasPago}
                    onChangeFn={onChangeFormPago}
                  />
                </SimpleContainer>
              </div>

              {showOpciones && (
                <div className="col-xl-6">
                  <SimpleContainer label="Elije cuántos meses" name="idPlazo">
                    <DropDownFilter
                      name="idPlazo"
                      filter={false}
                      rules={{ required: 'Obligatorio' }}
                      disabled={recalculando}
                      options={parametrosPago.plazos}
                      onChangeFn={onChangePlazo}
                    />
                  </SimpleContainer>
                </div>
              )}
            </div>
          </div>

          {showLogos && (
            <div className="col-12">
              <div className="ml-4">
                <h4>Tarjetas participantes</h4>

                {TARJETAS.AUTO.map((tarjeta, index) => (
                  <img
                    {...tarjeta}
                    key={index}
                    alt={tarjeta.alt}
                    style={{ width: '200px' }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResumenDatosPlan;
